// extracted by mini-css-extract-plugin
export var aligncenter = "blocks-module--aligncenter--124d2";
export var alignright = "blocks-module--alignright--c5fc5";
export var blockItemContent = "blocks-module--block-item-content--7096d";
export var blockItemTooltip = "blocks-module--blockItemTooltip--22ddc";
export var blockItemTooltipTrigger = "blocks-module--blockItemTooltipTrigger--a393d";
export var blocks = "blocks-module--blocks--c23e2";
export var blocksItem = "blocks-module--blocks-item--d9b7b";
export var blocksWrap = "blocks-module--blocks-wrap--d4501";
export var wpBlockJetpackGif = "blocks-module--wp-block-jetpack-gif--8e930";
export var wpBlockJetpackGifWrapper = "blocks-module--wp-block-jetpack-gif-wrapper--f6f02";